export class EclerVida {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.gpo = [false, false, false, false]; // false = open
        this.ipAddress = '';
        this.port = 0;
        this.power = false;
        this.asyncHandlers = [
            {
                name: 'Connect',
                regExp: /GET ALL/i,
                callback: (match) => {
                    const responses = this.getAllResponses();
                    for (const response of responses) {
                        this.socket.send(this.ipAddress, this.port, `${response}\n`);
                    }
                },
            },
            {
                name: 'Connect',
                regExp: /SYSTEM CONNECT/i,
                callback: (match) => {
                    this.socket.send(this.ipAddress, this.port, `DATA INFO_NAME "VidaAmp"\n`);
                },
            },
            {
                name: 'Disconnect',
                regExp: /SYSTEM DISCONNECT/i,
                callback: (match) => {
                    this.socket.send(this.ipAddress, this.port, `ERROR 0 "Now Disconnected"\n`);
                },
            },
            {
                name: 'Get Source/Output MUTE',
                regExp: /GET\s+(SMUTE|OMUTE)\s+(\d+)/i,
                callback: (match) => {
                    const chanType = match[1].toLowerCase() === 'SMUTE' ? 'source' : 'output';
                    const chan = parseInt(match[2], 10);
                    const value = this.audioChans[chanType][chan - 1].mute;
                    this.socket.send(this.ipAddress, this.port, `DATA ${match[1]} ${chan} ${value ? 'YES' : 'NO'}\n`);
                },
            },
            {
                name: 'Set Source/Output MUTE',
                regExp: /SET\s+(SMUTE|OMUTE)\s+(\d+)\s+(YES|NO)/i,
                callback: (match) => {
                    const chanType = match[1].toLowerCase() === 'SMUTE' ? 'source' : 'output';
                    const chan = parseInt(match[2], 10);
                    const value = match[3].toLowerCase() === 'yes';
                    this.audioChans[chanType][chan - 1].mute = value;
                    // No responses on SET commands
                },
            },
            {
                name: 'Get Zone source selection',
                regExp: /GET\s+ZONERIN\s+(\d+)/i,
                callback: (match) => {
                    var _a, _b;
                    const zone = parseInt(match[1], 10);
                    const src = (_b = (_a = this.zones[zone - 1]) === null || _a === void 0 ? void 0 : _a.src) !== null && _b !== void 0 ? _b : 'S1';
                    this.socket.send(this.ipAddress, this.port, `DATA ZONERIN ${zone} ${src}\n`);
                },
            },
            {
                name: 'Set Zone source selection',
                regExp: /SET\s+ZONERIN\s+(\d+)\s+([SAO]\d+)/i,
                callback: (match) => {
                    const zone = parseInt(match[1], 10);
                    const src = match[2];
                    this.zones[zone - 1].src = src;
                    // No responses on SET commands
                },
            },
            {
                name: 'Get Group MUTE',
                regExp: /GET\s+GMUTE\s+(Gen|Loc|Net)\s*(\d+)?/i,
                callback: (match) => {
                    var _a;
                    const chanType = 'group';
                    const groupType = match[1];
                    const chan = parseInt((_a = match[2]) !== null && _a !== void 0 ? _a : '1', 10);
                    const chanData = this.audioChans[chanType].find(element => element.groupType === groupType && element.index === chan);
                    const value = chanData ? chanData.mute : false;
                    this.socket.send(this.ipAddress, this.port, `DATA GMUTE ${groupType} ${groupType.toLowerCase() === 'gen' ? '' : chan + ' '}${value ? 'YES' : 'NO'}\n`);
                },
            },
            {
                name: 'Set Group MUTE',
                regExp: /SET\s+GMUTE\s+(Gen|Loc|Net)\s*(\d+)?\s+(YES|NO)/i,
                callback: (match) => {
                    const chanType = 'group';
                    const groupType = match[1];
                    const chan = match[2] ? parseInt(match[2], 10) : 1;
                    const value = match[3].toLowerCase() === 'yes';
                    const chanData = this.audioChans[chanType].find(element => element.groupType === groupType && element.index === chan);
                    if (chanData)
                        chanData.mute = value;
                    // No response on set
                },
            },
            {
                name: 'Get Crosspoint MUTE',
                regExp: /GET\s+XMUTE\s+(\d+)\s+(\d+)/i,
                callback: (match) => {
                    const inchan = parseInt(match[1], 10);
                    const outchan = parseInt(match[2], 10);
                    const value = this.crosspoints[inchan - 1][outchan - 1].mute;
                    this.socket.send(this.ipAddress, this.port, `DATA XMUTE ${inchan} ${outchan} ${value ? 'YES' : 'NO'}\n`);
                },
            },
            {
                name: 'Set Crosspoint MUTE',
                regExp: /SET\s+XMUTE\s+(\d+)\s+(\d+)\s+(YES|NO)/i,
                callback: (match) => {
                    const inchan = parseInt(match[1], 10);
                    const outchan = parseInt(match[2], 10);
                    const value = match[3].toLowerCase() === 'yes';
                    this.crosspoints[inchan - 1][outchan - 1].mute = value;
                    // No response on set
                },
            },
            {
                name: 'Get Crosspoint Level',
                regExp: /GET\s+XLEVEL\s+(\d+)\s+(\d+)/i,
                callback: (match) => {
                    const inchan = parseInt(match[1], 10);
                    const outchan = parseInt(match[2], 10);
                    const value = this.crosspoints[inchan - 1][outchan - 1].level;
                    this.socket.send(this.ipAddress, this.port, `DATA XLEVEL ${inchan} ${outchan} ${value}\n`);
                },
            },
            {
                name: 'Set Crosspoint Level',
                regExp: /SET\s+XLEVEL\s+(\d+)\s+(\d+)\s+(\d+)/i,
                callback: (match) => {
                    const inchan = parseInt(match[1], 10);
                    const outchan = parseInt(match[2], 10);
                    const value = parseInt(match[3], 10);
                    this.crosspoints[inchan - 1][outchan - 1].level = value;
                    // No response on set
                },
            },
            {
                name: 'Get LEVEL',
                regExp: /GET\s+(SLEVEL|OLEVEL)\s+(\d+)/i,
                callback: (match) => {
                    const chanType = match[1].toLowerCase() === 'SLEVEL' ? 'source' : 'output';
                    const chan = parseInt(match[2], 10);
                    const value = this.audioChans[chanType][chan - 1].level;
                    this.socket.send(this.ipAddress, this.port, `DATA ${match[1]} ${chan} ${value}\n`);
                },
            },
            {
                name: 'Set LEVEL',
                regExp: /SET\s+(SLEVEL|OLEVEL)\s+(\d+)\s+(\d+)/i,
                callback: (match) => {
                    const chanType = match[1].toLowerCase() === 'SLEVEL' ? 'source' : 'output';
                    const chan = parseInt(match[2], 10);
                    const value = parseInt(match[3], 10);
                    this.audioChans[chanType][chan - 1].level = value;
                    // No response from Set commands
                },
            },
            {
                name: 'Get Group LEVEL',
                regExp: /GET\s+GLEVEL\s+(Gen|Loc|Net)\s*(\d+)?/i,
                callback: (match) => {
                    var _a;
                    const chanType = 'group';
                    const groupType = match[1];
                    const chan = parseInt((_a = match[2]) !== null && _a !== void 0 ? _a : '1', 10);
                    const chanData = this.audioChans[chanType].find(element => element.groupType === groupType && element.index === chan);
                    const value = chanData ? chanData.level : 0;
                    this.socket.send(this.ipAddress, this.port, `DATA GLEVEL ${groupType} ${groupType === 'Gen' ? '' : chan + ' '}${value}\n`);
                },
            },
            {
                name: 'Set Group LEVEL',
                regExp: /SET\s+GLEVEL\s+(Gen|Loc|Net)\s*(\d+)?\s+(\d+)/i,
                callback: (match) => {
                    const chanType = 'group';
                    const groupType = match[1];
                    const chan = match[2] ? parseInt(match[2], 10) : 1;
                    const value = parseInt(match[3], 10);
                    const chanData = this.audioChans[chanType].find(element => element.groupType === groupType && element.index === chan);
                    if (chanData)
                        chanData.level = value;
                    // No response on set
                },
            },
            {
                name: 'Get GPO',
                regExp: /GET\s+GPO\s+(\d+)/i,
                callback: (match) => {
                    const chan = parseInt(match[1], 10);
                    const value = this.gpo[chan - 1] ? 'YES' : 'NO';
                    this.socket.send(this.ipAddress, this.port, `DATA GPO ${chan} ${value}\n`);
                },
            },
            {
                name: 'Set GPO',
                regExp: /SET\s+GPO\s+(\d+)\s+(YES|NO)/i,
                callback: (match) => {
                    const chan = parseInt(match[1], 10);
                    this.gpo[chan - 1] = match[2] === 'YES';
                    // No response on set
                },
            },
            {
                name: 'Set Preset',
                regExp: /SET\s+PRESET\s+(\d+)/i,
                callback: (match) => {
                    // No responses on Set
                },
            },
            {
                name: 'Get Power',
                regExp: /GET\s+POWER/i,
                callback: (match) => {
                    this.socket.send(this.ipAddress, this.port, `DATA POWER ${this.power ? 'RUNNING' : 'SLEEPING'}\n`);
                },
            },
            {
                name: 'Set Power',
                regExp: /SET\s+POWER\s+(ON|OFF)/i,
                callback: (match) => {
                    this.power = match[1].toLowerCase() === 'on';
                    // No responses on Set
                },
            },
        ];
        // Initialize the cross point matrix
        this.crosspoints = [];
        for (let i = 0; i < 4; i++) {
            this.crosspoints[i] = [];
            for (let j = 0; j < 6; j++) {
                this.crosspoints[i][j] = { mute: false, level: 100 };
            }
        }
        this.zones = [];
        for (let i = 0; i < 10; i++) {
            this.zones[i] = { mute: false, src: 'S1' };
        }
        this.audioChans = {
            source: [
                { index: 1, mute: false, level: 100 },
                { index: 2, mute: false, level: 100 },
                { index: 3, mute: false, level: 100 },
                { index: 4, mute: false, level: 100 },
            ],
            output: [
                { index: 1, mute: false, level: 100 },
                { index: 2, mute: false, level: 100 },
                { index: 3, mute: false, level: 100 },
                { index: 4, mute: false, level: 100 },
                { index: 5, mute: false, level: 100 },
                { index: 6, mute: false, level: 100 },
                { index: 7, mute: false, level: 100 },
                { index: 8, mute: false, level: 100 },
                { index: 9, mute: false, level: 100 },
                { index: 10, mute: false, level: 100 },
            ],
            group: [
                { groupType: 'Gen', index: 1, mute: false, level: 100 },
                { groupType: 'Loc', index: 1, mute: false, level: 100 },
                { groupType: 'Loc', index: 2, mute: false, level: 100 },
                { groupType: 'Loc', index: 3, mute: false, level: 100 },
                { groupType: 'Loc', index: 4, mute: false, level: 100 },
                { groupType: 'Net', index: 1, mute: false, level: 100 },
                { groupType: 'Net', index: 2, mute: false, level: 100 },
                { groupType: 'Net', index: 3, mute: false, level: 100 },
                { groupType: 'Net', index: 4, mute: false, level: 100 },
            ],
        };
    }
    onConfigure(config) {
        var _a, _b;
        this.ipAddress = (_a = config.ipAddress) !== null && _a !== void 0 ? _a : '';
        this.port = (_b = config.port) !== null && _b !== void 0 ? _b : 0;
    }
    getAllResponses() {
        const responses = [];
        responses.push(`DATA INFO_MODEL VIDA-24Q`);
        responses.push(`DATA INFO_VERSION v1.04r38`);
        responses.push(`DATA INFO_MAC NET1 E4:5F:01:F8:22:3B`);
        responses.push(`DATA INFO_MAC NET2 00:1A:96:01:39:03`);
        responses.push(`DATA INFO_IPLIST 1 192.168.100.113 62645`);
        responses.push(`DATA INFO_NAME "Crestline2"`);
        responses.push(`DATA IP_CONFIG NET1 192.168.0.100 255.255.255.0 192.168.0.1`);
        responses.push(`DATA IP_CONFIG NET2 192.168.1.155 0.0.0.0 0.0.0.0`);
        responses.push(`DATA DEVICE_ERROR 0x0000000000000000`);
        responses.push(`DATA PRESET "Factory Preset"`);
        responses.push(`DATA POWER ${this.power ? 'RUNNING' : 'SLEEPING'}`);
        for (const [audioType, audioChans] of Object.entries(this.audioChans)) {
            const levelType = audioType === 'source' ? 'SLEVEL' : audioType === 'output' ? 'OLEVEL' : 'GLEVEL';
            audioChans.forEach((chan, i) => responses.push(`DATA ${levelType}${(chan === null || chan === void 0 ? void 0 : chan.groupType) ? ' ' + chan.groupType : ''}${chan.index ? ' ' + chan.index : ''} ${chan.level}`));
            const muteType = audioType === 'source' ? 'SMUTE' : audioType === 'output' ? 'OMUTE' : 'GMUTE';
            audioChans.forEach((chan, i) => responses.push(`DATA ${muteType}${(chan === null || chan === void 0 ? void 0 : chan.groupType) ? ' ' + chan.groupType : ''}${(chan === null || chan === void 0 ? void 0 : chan.index) ? ' ' + chan.index : ''} ${chan.mute ? 'YES' : 'NO'}`));
        }
        // crosspoints
        const numins = this.crosspoints.length;
        for (let i = 0; i < numins; i++) {
            const numouts = this.crosspoints[i].length;
            for (let j = 0; j < numouts; j++) {
                responses.push(`DATA XLEVEL ${i + 1} ${j + 1} ${this.crosspoints[i][j].level}`);
            }
        }
        for (let i = 0; i < numins; i++) {
            const numouts = this.crosspoints[i].length;
            for (let j = 0; j < numouts; j++) {
                responses.push(`DATA XMUTE ${i + 1} ${j + 1} ${this.crosspoints[i][j].mute ? 'YES' : 'NO'}`);
            }
        }
        responses.push(`DATA SVU 1 0 0`);
        responses.push(`DATA SVU 2 0 0`);
        responses.push(`DATA SVU 3 0 0`);
        responses.push(`DATA SVU 4 0 0`);
        responses.push(`DATA OVU 1 0`);
        responses.push(`DATA OVU 2 0`);
        responses.push(`DATA OVU 3 0`);
        responses.push(`DATA OVU 4 0`);
        responses.push(`DATA OVU 5 0`);
        responses.push(`DATA OVU 6 0`);
        responses.push(`DATA ALARM_PROTECT 1 OFF`);
        responses.push(`DATA ALARM_PROTECT 2 OFF`);
        responses.push(`DATA ALARM_PROTECT 3 OFF`);
        responses.push(`DATA ALARM_PROTECT 4 OFF`);
        responses.push(`DATA ALARM_FAULT 1 OFF`);
        responses.push(`DATA ALARM_FAULT 2 OFF`);
        responses.push(`DATA ALARM_FAULT 3 OFF`);
        responses.push(`DATA ALARM_FAULT 4 OFF`);
        responses.push(`DATA GPI 1 0`);
        responses.push(`DATA GPI 2 0`);
        responses.push(`DATA GPI 3 0`);
        responses.push(`DATA GPI 4 0`);
        this.gpo.forEach((pin, i) => responses.push(`DATA GPO ${i + 1} ${pin ? 'YES' : 'NO'}`));
        responses.push(`DATA EXTMUTE NO`);
        this.zones.forEach((zone, i) => responses.push(`DATA ZONERIN ${i + 1} ${this.zones[i]}`));
        responses.push(`DATA Z_MONITOR 1 0`);
        responses.push(`DATA Z_MONITOR 2 0`);
        responses.push(`DATA Z_MONITOR 3 0`);
        responses.push(`DATA Z_MONITOR 4 0`);
        responses.push(`DATA PLAYER_MUTE NO`);
        responses.push(`DATA PLAYER_VOLUME 36`);
        responses.push(`DATA PLAYER_VUMETERS 0 0`);
        responses.push(`DATA PLAYER_TIME 0:00 0:00 0:00`);
        responses.push(`DATA PLAYER_CONTROL PAUSE`);
        responses.push(`DATA PLAYER_PLAYLIST_NAME ""`);
        responses.push(`DATA PLAYER_QUEUE_INFO 1 0`);
        responses.push(`DATA PLAYER_PLAY_MODE SEQUENTIAL`);
        responses.push(`DATA PLAYER_REPEAT_MODE PLAYALL`);
        responses.push(`DATA PLAYER_FADE_MODE FADE`);
        responses.push(`DATA PLAYER_ITEM_TAGS "" "" ""`);
        return responses;
    }
}
EclerVida.emulatorType = 'udpEmulator';
EclerVida.key = '-O339wPeb6O6jf1ZIRlq';
